module.exports = __webpack_public_path__ + "img/banner-2.093d0c10.png";